import React from "react";

type Props = {
  title?: string;
  children: React.ReactNode;
  column?: boolean;
  grid?: boolean;
};

export const TemplateCard = ({ grid, children }: Props) => (
  <div
    className={`${
      grid && "grid grid-cols-1 lg:grid-cols-2"
    } h-min max-w-4xl  bg-cards shadow-md lg:rounded-lg`}
  >
    {children}
  </div>
);

export const TemplateCardContent = ({ title, children, column }: Props) => (
  <div className="px-12 py-8 ">
    <h1 className="mb-5 text-center text-2xl font-semibold tracking-tight text-gray-800  ">
      {title}
    </h1>
    <div
      className={`flex ${
        column ? "flex-col" : "flex-row"
      } flex-wrap items-center justify-center gap-5`}
    >
      {children}
    </div>
  </div>
);
